import { UserService } from "./User";
import { DepositService } from "./Deposit";
import { TransferOptionsService } from "./TransferOptions";
import { WithdrawService } from './Withdraw';
import {InternalTransferService} from './InternalTransfer';
import { CryptoService } from "./CryptoService";
import { DocumentService } from "./DocumentService";

export const Service = {
    User: UserService,
    Deposit: DepositService,
    TransferOptions: TransferOptionsService,
    Withdraw: WithdrawService,
    InternalTransfer:InternalTransferService,
    CryptoService:CryptoService,
    DocumentService:DocumentService
}